module.exports = __webpack_public_path__ + "static/media/Womenformimg.739dcf10.png";